import React, { useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import { FaExclamationTriangle, FaCheckCircle } from "react-icons/fa";
import Box from "../../hoc/Box/Box";
import Alert from "../../components/UI/Alert/Alert";
import classes from "./NetworkPage.css";
import * as actions from "../../store/actions/index";
import ChangeLog from "../../containers/ChangeLog/ChangeLog";
// import SpeedBoostLog from "../../containers/SpeedBoostLog/SpeedBoostLog";
import PreviousSpeedCheckResult from "../../containers/RouterSpeedCheck/PreviousSpeedCheckResult";
import WifiServiceCheck from "../../containers/WifiServiceCheck/WifiServiceCheck";
import RouterSpeedCheck from "../../containers/RouterSpeedCheck/RouterSpeedCheck";
import AdvancedSecurity from "../../containers/AdvancedSecurity/AdvancedSecurity";
import SecondSSID from "../../containers/SecondSSID/SecondSSID";
import SecurityLog from "../../containers/SecurityLog/SecurityLog";
import Confirm from "../../components/UI/Confirm/Confirm";
import Modal from "../../components/UI/Modal/Modal";
import api from "../../axios-local-api";

const NetworkPage = (props) => {
	const [confirmModal, setConfirmModal] = useState(false);
	const [result, setResult] = useState('');
	const [showPspAlert, setShowPspAlert] = useState(null);
	const [restoreInitiated, setRestoreInitiated] = useState(false);
	const [wscError, setWscError] = useState(false);
	const [haveSTResults, setHaveSTResults] = useState(false)
	const CssoLogin = (sessionStorage.getItem("userRoles") || []).includes('CSSO');

	useEffect(() => {
		if(!props.location.hash) return;
		const id = props.location.hash.replace('#', '');
		setTimeout(() => {
			const element = document.getElementById(id);
			if(element){
				element.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				})
			}
		}, 100)

	}, [props.location.hash])

	useEffect(() => {
		// console.log('props::',showPspAlert, props?.tenantData, props.enablementStaus )
		const isSuspendedFromTenant =
			["SUSPENDED", "OFFLINE_SUSPENDED"].includes(props.tenantData?.connectionStatus) ||
			["SUSPENDED", "OFFLINE_SUSPENDED"].includes(props.tenantData?.residentPrivateNetwork?.opStatus)
		// const isNoService = props.enablementStaus === "noService";
		const isTenantAccount = sessionStorage.getItem('type')?.includes('Tenant');
		const isUnitAccount = sessionStorage.getItem('subclass') === 'UNIT';
		const isSpectrumReady = (sessionStorage.getItem('isSpectrumReady') === 'true' || isTenantAccount) || !props.specReadyConnectivity;
		const isSpectrumReadySuspended = props.spectrumStatus.data?.tenantWifiState?.includes("suspended")
		const spectrumDataLoaded = !props.spectrumStatusLoading && !props.spectrumStatusError;

		if (

			!isUnitAccount &&
			(showPspAlert === null) &&
			((((props?.tenantData?.connectionStatus === "SUSPENDED" || props?.tenantData?.connectionStatus === "OFFLINE_SUSPENDED") || props?.tenantData?.residentPrivateNetwork?.opStatus
				=== "SUSPENDED" || props?.tenantData?.residentPrivateNetwork?.opStatus
				=== "OFFLINE_SUSPENDED") && props?.enablementStaus === "noService") ||
			(isSpectrumReady && spectrumDataLoaded && isSpectrumReadySuspended))

		) {
			setShowPspAlert('alert')
		} else if (

			restoreInitiated &&
			(showPspAlert !== "success" && showPspAlert !== null) &&
			spectrumDataLoaded &&
			(
				// Non-spectrum-ready: check tenant data is no longer suspended
				(!isSpectrumReady &&
					!((props?.tenantData?.connectionStatus === "SUSPENDED" || props?.tenantData?.connectionStatus === "OFFLINE_SUSPENDED") || props?.tenantData?.residentPrivateNetwork?.opStatus
						=== "SUSPENDED" || props?.tenantData?.residentPrivateNetwork?.opStatus
						=== "OFFLINE_SUSPENDED") && props?.enablementStaus !== "noService"
				) ||
				// Spectrum-ready: check spectrum status is no longer suspended
				(isSpectrumReady && !isSpectrumReadySuspended)
			)
		) {
			setShowPspAlert("success")
		}
	}, [
		props.tenantData?.connectionStatus,
		props.tenantData?.residentPrivateNetwork?.opStatus,
		props.enablementStaus,
		props.spectrumStatusLoading,
		props.spectrumStatusError,
		props.spectrumStatus,
		showPspAlert,
		restoreInitiated
	])

	// Show success banner when restore is successful from PropertyManager view
	useEffect(() => {
		if (props.restoreServiceSuccess && showPspAlert !== "success") {
			setShowPspAlert("success");
		}
	}, [props.restoreServiceSuccess])

	useEffect(() => {
		if ((props?.qoeScoresLoaded && props?.qoeScores.length === 0) || props?.wan?.error) {
			setWscError(true);
		} else {
			setWscError(false);
		}
	}, [props?.qoeScores, props?.wan?.error])

	useEffect(() => {
		const isSpecReady = sessionStorage.getItem('isSpectrumReady') === 'true';
		const type = sessionStorage.getItem('type');
		const isTenant = type?.includes('Tenant');
		if (isSpecReady || isTenant) {
			props.getSpectrumStatus()
		}
	}, [])
	useEffect(() => {
		if (!haveSTResults) {
			props.getSpeedCheckResults()
		}
		if (props.speedCheckResults && props.speedCheckResults.length) {
			setHaveSTResults(true)
		}
	}, [])

	const confirmModalCancelHandler = () => {
		setConfirmModal(false);
	};

	const openModal = async () => {
		const currentAccountNumber = sessionStorage.getItem('accountNumber');
		const currentMac = sessionStorage.getItem('mac');
		const masterAcct = props.tenantData?.bulkMasterAccount || sessionStorage.getItem('masterAcct');
		let tenantAddressLine1 = sessionStorage.getItem('tenantAddressLine1') || '';
		let tenantAddressLine2 = sessionStorage.getItem('tenantAddressLine2') || '';
		
		if ((!tenantAddressLine1 || !tenantAddressLine2) && masterAcct && masterAcct !== 'null' && masterAcct !== 'undefined') {
			try {
				const pspPage = sessionStorage.getItem('pspPage') || 0;
				const response = await api.get(`/psp/getInfo/${masterAcct}`, {
					params: { search: '', page: pspPage, size: 100 }
				});
				const tenants = response?.data?.tenantData?.data?.content;
				if (Array.isArray(tenants)) {
					const tenantInfo = tenants.find(t =>
						t && (t.accountNumber === currentAccountNumber || t.routerMac === currentMac)
					);
					if (tenantInfo) {
						tenantAddressLine1 = tenantInfo.tenantAddressLine1 || tenantAddressLine1;
						tenantAddressLine2 = tenantInfo.tenantAddressLine2 || tenantAddressLine2;
					}
				}
			} catch (error) {
				console.error('Error fetching tenant info:', error);
			}
		}
		
		const modalContent = (
			<div
				style={{
					display: "flex",
					alignItems: "center",
					flexDirection: "column",
				}}
			>
				<span style={{ margin: "0px 0px 0px 10px", whiteSpace: "nowrap", fontWeight: "normal" }}>You are Restoring service to</span>
				<span style={{ margin: "0px 0px 0px 50px", fontWeight: "bold", textAlign: "center" }}>
					{tenantAddressLine1 && tenantAddressLine2 ? `${tenantAddressLine1}, ${tenantAddressLine2}` : tenantAddressLine1 || 'Address not available'}
				</span>
				<br />
				<span style={{ margin: "0px 0px 0px 82px", textAlign: "center", fontWeight: "normal" }}>Are you sure you want to proceed?</span>
			</div>
		);
		setResult(modalContent);
		setConfirmModal(true);
	};

	const confirmModalConfirmHandler = () => {
		const { routerMac, tenantFirstName, bulkMasterAccount } = props.tenantData || {};
		
		// Fallback to sessionStorage if tenantData is not available (AOS access)
		const mac = routerMac || sessionStorage.getItem('mac');
		const masterAcct = bulkMasterAccount || sessionStorage.getItem('masterAcct');
		const isTenant = sessionStorage.getItem('type')?.includes('Tenant');
		const isSpectrumReady = sessionStorage.getItem('isSpectrumReady') === 'true' || isTenant;
		
		// Validate required parameters before making API calls
		if (!mac || mac === 'null' || mac === 'undefined') {
			console.error('Cannot restore service: Invalid or missing MAC address');
			setConfirmModal(false);
			return;
		}
		
		if (!masterAcct || masterAcct === 'null' || masterAcct === 'undefined') {
			console.error('Cannot restore service: Invalid or missing master account');
			setConfirmModal(false);
			return;
		}
		
		const payload = {
			tenantName: tenantFirstName,
			propertyName: null,
			tenantAccountNumber: null,
			tenantAccountDivisionId: null,
			tenantAccountRouterMac: null,
			bulkMasterAccount: masterAcct,
		};
		
		if (isSpectrumReady) {
			props.resumeSpecReadyServiceTenantAccount(mac, masterAcct);
		} else {
			props.restoreServiceTenantAccount(mac, payload);
		}

		setRestoreInitiated(true);
		setConfirmModal(false);
		setTimeout(() => {
			props.onInitWan();
			props.onInitEquipment();
			props.onRefreshDevices(props.selectedEquipment);
			props.getSpectrumStatus();
		}, 3000)
		// Fallback: show success banner after 6 seconds if not already shown
		setTimeout(() => {
			setShowPspAlert((prev) => prev !== "success" ? "success" : prev);
		}, 6000)
	};

	const advancedSecurity = useMemo(() => {
		if (
			sessionStorage.getItem("featureFlags").includes("advancedSpec") &&
			!props?.advancedSecurity?.advancedSecurity?.listenOnly
		) {
			return (
				<div className={classes.MainContentContainer}>
					<AdvancedSecurity deskId="advancedSecurityLogSection" />
					<div className={classes.Spacer} />
				</div>
			);
		}

	}, [sessionStorage.getItem("featureFlags"), props?.advancedSecurity?.advancedSecurity?.listenOnly])


	const securityLog = useMemo(() => {
		if (
			sessionStorage.getItem("featureFlags").includes("advancedSpec") &&
			!props?.advancedSecurity?.advancedSecurity?.listenOnly
		) {
			return (
				<div className={classes.MainContentContainer}>
					<SecurityLog />
					<div className={classes.Spacer} />
				</div>
			);
		}

	}, [sessionStorage.getItem("featureFlags"), props?.advancedSecurity?.advancedSecurity?.listenOnly])

	const secondSSID = (
		<div className={classes.MainContentContainer}>
			<SecondSSID deskId="secondSSIDSection" page="network" />
			<div className={classes.Spacer} />
		</div>
	);


	const pspWarning = useMemo(() => {
		// Only show warning at "All Equipment" level
		const isAllEquipmentView = props.selectedEquipment?.type === "equipment";
		
		if (!isAllEquipmentView) {
			return null;
		}
		
		if (showPspAlert === "alert") {
			return (
				<div className={classes.MainContentContainer}>
					<Alert
						AlertIcon="PSPAlertIcon"
						Icon={FaExclamationTriangle}
						iconColor="red"
						iconFontSize="28px"
						textMessage="Customer connection has been suspended by property manager.
            Please have customer contact property manager"
						txtId="PSPAlertTxt"
						buttonText="Restore Service"
						buttonId="PSPRestoreBtn"
						buttonCallBack={openModal}
					/>
					<div className={classes.Spacer} />
				</div>
			);
		} else if (showPspAlert === "success") {
			return (
				<div className={classes.MainContentContainer}>
					<Alert
						Icon={FaCheckCircle}
						iconColor="green"
						iconFontSize="28px"
						id={'NetworkInfoSuccess'}
						textMessage="Service has been successfully restored"
					/>
					<div className={classes.Spacer} />
				</div>
			);
		}
	}, [showPspAlert, props.selectedEquipment?.type])

	const featureFlags = sessionStorage.getItem("featureFlags");

	const routerSpeedCheck = featureFlags.includes('speedTest')
		? (<><RouterSpeedCheck /><div className={classes.Spacer} /></>)
		: <div />;

	const routerSpeedHistory = featureFlags.includes('speedTest')
		? (<><PreviousSpeedCheckResult onSetResultsLoaded={props.onSetResultsLoaded} onSetResultsLoading={props.onSetResultsLoading} speedCheckResults={props.speedCheckResults} getSpeedCheckResults={props.getSpeedCheckResults} resultsLoading={props.resultsLoading} resultsLoaded={props.resultsLoaded} /><div className={classes.Spacer} /></>)
		: <div />;

	const changeLog = <ChangeLog />;
	// const speedBoostLog = featureFlags.includes('speedBoost') ? (<><SpeedBoostLog /><div className={classes.Spacer} /></>) : <div />;

	const wifiServiceCheck = featureFlags.includes('wifiService') ? (<><WifiServiceCheck wscError={wscError} /><div className={classes.Spacer} /></>) : <div />;


	return (
		<Box>
			<div className={classes.MainContent}>
				{pspWarning}
				<div className={classes.MainContentContainer}>
					{wifiServiceCheck}
				</div>
				{props.routerSpeedCheckVisible && (
					<div className={classes.MainContentContainer}>
						{routerSpeedCheck}
					</div>
				)}
				<div className={classes.MainContentContainer}>
					{routerSpeedHistory}
				</div>
				{/* {
					!sessionStorage.getItem('featureFlags')?.includes('isVar') &&
					<div className={classes.MainContentContainer}>
						{speedBoostLog}
					</div>
				} */}

				{sessionStorage.getItem("type")?.includes("Business") && sessionStorage.getItem("featureFlags")?.includes("secondSSID") && secondSSID}
				{!sessionStorage.getItem('featureFlags')?.includes('isVar') && advancedSecurity}

				{!sessionStorage.getItem('featureFlags')?.includes('isVar') && securityLog}
				<div className={classes.MainContentContainer}>{changeLog}</div>
			</div>
			{confirmModal && (
				<Modal deviceGroupConfirmation={"true"} show={confirmModal} modalClosed={confirmModalCancelHandler}>
					<Confirm
						deviceGroupConfirmation
						result={result}
						confirm={confirmModalConfirmHandler}
						cancel={confirmModalCancelHandler}
						cancelButtonLabel="Cancel"
						confirmButtonLabel="Proceed"
						hideActionText={true}
					/>
				</Modal>
			)}
		</Box>
	);



}

const mapStateToProps = (state) => {
	return {
		specReadyConnectivity: state.spectrumReady.connectivity,
		spectrumStatus: state.spectrumReady.spectrumStatus,
		spectrumStatusLoading: state.spectrumReady.spectrumStatusLoading,
		spectrumStatusError: state.spectrumReady.spectrumStatusError,
		isAuthenticated: state.auth.token !== null,
		isPinxt: state.auth.pToken !== null,
		loggedinUserId: sessionStorage.getItem("userId"),
		account: state.settings.account,
		realDevices: state.devices.realDevices,
		devicesByEquipment: state.devices.devicesByEquipment,
		bandwidthDays: state.bandwidth.days,
		realBandwidth: state.bandwidth.realBandwidth,
		selectedEquipment: state.equipment.selectedEquipment,
		showTimeRemaining: state.settings.showTimeRemaining,
		wan: state.wan,
		realWan: state.wan.realWan,
		tenantData: state.wan.tenantData,
		equipment: state.equipment,
		firmware: state.settings.firmwareUpdate,
		speedCheckResults: state.speedCheck.speedCheckResults,
  		speedCheckResultsError: state.speedCheck.speedCheckResultsError,
		resultsLoading: state.speedCheck.resultsLoading,
		resultsLoaded: state.speedCheck.resultsLoaded,
		mobileHomeActive:
			state.mobileHome.realMobileHome &&
				state.mobileHome.realMobileHome.subscription &&
				state.mobileHome.realMobileHome.subscription &&
				state.mobileHome.realMobileHome.subscription.status
				? state.mobileHome.realMobileHome.subscription.status
				: null,
		claimedPods: state.equipment.realEquipment ? state.equipment.realEquipment.claimedPods : [],
		advancedSecurity: state.advancedSecurity,
		routerSpeedCheckVisible: state.speedCheck.routerSpeedCheckVisible,
		qoeScores: state.qoe.qoeScores,
		qoeScoresLoaded: state.qoe.qoeScoresLoaded,
		enablementStaus: state.spectrumReady.status,
		restoreServiceSuccess: state.propertyManager.restoreServiceSuccess,
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		getSpeedCheckResults: () => dispatch(actions.getSpeedCheckResults()),
		getSpectrumStatus: () => dispatch(actions.initGetSpectrumStatus()),
		restoreServiceTenantAccount: (routerMac, payload) =>
			dispatch(actions.restoreServiceTenantAccount(routerMac, null, payload)),
		resumeSpecReadyServiceTenantAccount: (routerMac, masterAccNum) =>
			dispatch(actions.resumeSpecReadyServiceTenantAccount(routerMac, masterAccNum)),
		onInitEquipment: () => dispatch(actions.initEquipment()),
		onInitWan: () => dispatch(actions.initWan()),
		onRefreshDevices: (selectedEquipment) =>
			dispatch(actions.refreshDevices(selectedEquipment)),
		onSetResultsLoaded: (val) => dispatch(actions.setResultsLoaded(val)),
		onSetResultsLoading: (val) => dispatch(actions.setResultsLoading(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(NetworkPage);
